/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
interface IProps {
	width: string | number;
}

function FeedbackRespondInstructionsIllustration({ width = 406 }: IProps) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={width} viewBox="0 0 406 278">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<g fillRule="nonzero">
					<g fill="#CCC" opacity="0.27">
						<path d="M67.32 19.54c46.55-20.63 108.43-23.06 158-14.77 30.77 5.14 62.27 13.82 92 23.26 20.36 6.47 40.48 16.39 53.74 33.14 15 18.91 18.65 44.36 14.31 67.62-2.06 11.06-7.43 20.36-10.57 30.92-3.82 12.86 1.17 24.9 1.73 37.79.54 12.27-4.56 24.28-12 34-13.66 17.88-34.32 32-55.7 38.76-36.3 11.51-75.79 6.91-113 3.68-35.36-3.07-71-.37-106.31-4.18-14-1.51-28.15-4.16-40.24-11.29-18.61-11-29.88-31.14-37.06-51.51a200.2 200.2 0 01-8.11-103.4c6.58-34.55 21.9-62.35 53.82-79.47 3.07-1.62 6.21-3.09 9.39-4.55z"></path>
					</g>
					<path fill="#006837" d="M39.93 205.73H41.93V256.8H39.93z"></path>
					<path
						fill="#F9AC30"
						d="M41.45 181.18l4.62 9.37a1 1 0 00.71.52l10.34 1.5a1 1 0 01.53 1.61l-7.49 7.29a1 1 0 00-.27.84l1.77 10.3a.94.94 0 01-1.37 1L41 208.74a.9.9 0 00-.87 0l-9.25 4.86a.94.94 0 01-1.37-1l1.76-10.3a.91.91 0 00-.27-.84l-7.48-7.29a1 1 0 01.52-1.61l10.34-1.5a.92.92 0 00.71-.52l4.63-9.37a.94.94 0 011.73.01z"
					></path>
					<path fill="#006837" d="M80.84 205.73H82.84V256.8H80.84z"></path>
					<path
						fill="#F9AC30"
						d="M82.36 181.18l4.63 9.37a.92.92 0 00.71.52l10.34 1.5a1 1 0 01.52 1.61l-7.48 7.29a.91.91 0 00-.27.84l1.76 10.3a.94.94 0 01-1.37 1l-9.2-4.87a.92.92 0 00-.88 0l-9.25 4.86a.94.94 0 01-1.37-1l1.77-10.3a1 1 0 00-.27-.84l-7.49-7.29a1 1 0 01.53-1.61l10.34-1.5a1 1 0 00.71-.52l4.62-9.37a.94.94 0 011.65.01z"
					></path>
					<path fill="#006837" d="M121.75 205.73H123.75V256.8H121.75z"></path>
					<path
						fill="#F9AC30"
						d="M123.28 181.18l4.62 9.37a.93.93 0 00.71.52l10.34 1.5a1 1 0 01.52 1.61l-7.47 7.29a1 1 0 00-.27.84l1.77 10.3a.94.94 0 01-1.37 1l-9.25-4.86a.92.92 0 00-.88 0l-9.25 4.86a.93.93 0 01-1.36-1l1.76-10.3a1 1 0 00-.27-.84l-7.48-7.29a1 1 0 01.52-1.61l10.34-1.5a.93.93 0 00.71-.52l4.63-9.37a.94.94 0 011.68 0z"
					></path>
					<path fill="#006837" d="M162.67 205.73H164.67V256.8H162.67z"></path>
					<path
						fill="#F9AC30"
						d="M164.19 181.18l4.62 9.37a1 1 0 00.71.52l10.34 1.5a1 1 0 01.53 1.61l-7.49 7.29a1 1 0 00-.27.84l1.77 10.3a.94.94 0 01-1.37 1l-9.25-4.86a.9.9 0 00-.87 0l-9.25 4.86a.94.94 0 01-1.37-1l1.76-10.3a.91.91 0 00-.27-.84l-7.48-7.29a1 1 0 01.52-1.61l10.34-1.5a.92.92 0 00.71-.52l4.63-9.37a.94.94 0 011.69 0z"
					></path>
					<path fill="#006837" d="M205.23 232.24H207.23V256.8H205.23z"></path>
					<path
						fill="#F9AC30"
						d="M207 218l2.9 5.87a.61.61 0 00.45.33l6.48.94a.59.59 0 01.33 1l-4.69 4.58a.56.56 0 00-.17.52l1.1 6.46a.58.58 0 01-.85.62l-5.8-3.05a.59.59 0 00-.55 0l-5.8 3.05a.58.58 0 01-.85-.62l1.1-6.46a.56.56 0 00-.17-.52l-4.69-4.58a.58.58 0 01.33-1l6.48-.94a.61.61 0 00.45-.33l2.85-5.87a.59.59 0 011.1 0z"
					></path>
					<ellipse cx="40.85" cy="256.45" fill="#006837" rx="11.58" ry="3.24"></ellipse>
					<ellipse cx="81.59" cy="256.45" fill="#006837" rx="11.58" ry="3.24"></ellipse>
					<ellipse cx="122.34" cy="256.45" fill="#006837" rx="11.58" ry="3.24"></ellipse>
					<ellipse cx="164.01" cy="256.45" fill="#006837" rx="11.58" ry="3.24"></ellipse>
					<ellipse cx="206.17" cy="256.45" fill="#006837" rx="9.13" ry="3.24"></ellipse>
					<path
						fill="#EF8D72"
						d="M280.35 123.66a27.64 27.64 0 01-7.39 0c-3-.61-5.57-1.07-6.39-.43-.82.64-.55 3.47.54 4.29 1.09.82.64 1.82 1.56 2.55.92.73 1.44 2.19 4.55 1.83a47.68 47.68 0 008.35-2.36s-1.57-3.54-1.22-5.88z"
					></path>
					<path
						fill="#57479D"
						d="M271.55 142.08s5.84-4.21 6.3-7.58c.46-3.37-3.93-11.14-10-12.87a9 9 0 00-9.58 3.19s1.6 2.38 1.6 2.24c0-.14 4.12-5.29 8.18-2.74 4.81 3 6.82 6.82 6.89 8.46.13 2.62-2.73 5.83-5.24 7l1.85 2.3z"
					></path>
					<path
						fill="#EF8D72"
						d="M275.69 123.92s-2.13-1.2-3.19-1.12c-1.63.12-2.42 4.64-1.1 5.54.37.25 1.32-.34 1.73-3.09 0 0-.13 3.39 4.35 3.39a18.29 18.29 0 00-1.79-4.72z"
					></path>
					<path
						fill="#EF8D72"
						d="M266.57 123.23a2.32 2.32 0 012.66 0c1.49.93 5.48 5.34 6 6.83.52 1.49-2.06 1.87-2.06 1.87a4.3 4.3 0 01-4.55-1.83 5 5 0 00-1-2 3.12 3.12 0 00-.54-.58s-2.03-2.43-.51-4.29z"
					></path>
					<path
						fill="#57479D"
						d="M257.23 122.83l17.1 23.06s-9.68 10.29-23.1 11l-9.46-25.35a1.7 1.7 0 01.71-2l11.92-7.26a2.14 2.14 0 012.83.55z"
					></path>
					<path fill="#57479D" d="M228.51 149.42L251.24 156.91 247.4 146.63 230.79 144.4z"></path>
					<path
						fill="#463D89"
						d="M230.05 147.2c-1.95 4.46-4.87 7.48-6.53 6.76-1.66-.72-1.44-4.93.51-9.39 1.95-4.46 4.87-7.48 6.54-6.75 1.67.73 1.43 4.92-.52 9.38z"
					></path>
					<path
						fill="#57479D"
						d="M228.88 146.69c-1.95 4.46-4.87 7.48-6.54 6.75-1.67-.73-1.43-4.92.52-9.38 1.95-4.46 4.87-7.48 6.53-6.76 1.66.72 1.44 4.93-.51 9.39z"
					></path>
					<path
						fill="#463D89"
						d="M249.64 127.65c-3.41 2-6.32 3.31-6.51 3-.19-.31 2.44-2.17 5.85-4.14 3.41-1.97 6.33-3.31 6.51-3 .18.31-2.43 2.17-5.85 4.14zM226.08 141.31c-.12.29-.31.49-.42.44-.11-.05-.09-.32 0-.61s.32-.48.43-.44c.11.04.12.3-.01.61zM228.6 140.94c-.12.29-.31.48-.42.44-.11-.04-.09-.32 0-.61s.32-.48.43-.44c.11.04.12.32-.01.61zM228.24 144.05c-.13.29-.32.49-.42.44-.1-.05-.1-.32 0-.61s.31-.48.42-.43c.11.05.12.32 0 .6zM226.83 143.2c-.13.29-.32.49-.42.44-.1-.05-.1-.32 0-.61s.31-.48.42-.43c.11.05.17.32 0 .6zM224.86 146.88c-.12.29-.31.48-.42.44-.11-.04-.09-.32 0-.61s.32-.48.43-.44c.11.04.13.32-.01.61zM223.57 149.84c-.12.28-.31.48-.42.43-.11-.05-.09-.32 0-.6.09-.28.32-.49.43-.44.11.05.12.32-.01.61zM226.7 146.47c-.12.29-.31.48-.42.43-.11-.05-.09-.31 0-.6s.32-.49.43-.44c.11.05.12.32-.01.61zM225.67 148.83c-.13.29-.31.49-.42.44-.11-.05-.09-.32 0-.61s.32-.48.42-.43c.1.05.13.31 0 .6zM224.56 144.79c-.12.29-.31.48-.42.44-.11-.04-.09-.32 0-.61s.32-.48.43-.44c.11.04.12.32-.01.61zM223.2 147.91c-.12.29-.31.48-.42.44-.11-.04-.09-.32 0-.61s.32-.49.42-.44c.1.05.13.32 0 .61z"
					></path>
					<path
						fill="#BDDCFF"
						d="M225.48 149.15a8.79 8.79 0 00-8.17.95 14.6 14.6 0 00-4.91 6.84c-2.07 5.35-2.47 11.16-2.89 16.87-.42 5.71-.43 11.48-.27 17.22.16 5.74.48 11.49 1.05 17.21-.71-5.7-1.16-11.45-1.35-17.2-.19-5.75-.18-11.51.14-17.26.32-5.75.85-11.57 3-17a14.79 14.79 0 015.08-6.91 8.84 8.84 0 018.32-.72z"
					></path>
					<path
						fill="#BDDCFF"
						d="M224.48 146.56a8.79 8.79 0 00-8.17.95 14.54 14.54 0 00-4.9 6.83c-2.07 5.36-2.48 11.17-2.89 16.88-.41 5.71-.44 11.48-.27 17.22.17 5.74.48 11.49 1.05 17.21a187.953 187.953 0 01-1.35-17.2c-.21-5.75-.19-11.51.13-17.26.32-5.75.86-11.57 3-17a14.88 14.88 0 015.09-6.91 8.82 8.82 0 018.31-.72z"
					></path>
					<path
						fill="#BDDCFF"
						d="M226.51 142.71a10.08 10.08 0 00-8.52.56 13.42 13.42 0 00-5.45 6.69c-2.31 5.45-2.67 11.46-3.11 17.33-.44 5.87-.44 11.83-.31 17.74.13 5.91.4 11.84.89 17.74-.63-5.89-1-11.81-1.19-17.73-.19-5.92-.15-11.86.18-17.78.33-5.92.82-11.94 3.22-17.44a13.75 13.75 0 015.64-6.78 10.09 10.09 0 018.65-.33z"
					></path>
					<path
						fill="#BDDCFF"
						d="M225.48 141.66a11 11 0 00-8.72 0 12.41 12.41 0 00-5.86 6.47 32.16 32.16 0 00-2.37 8.62c-.41 3-.68 6-.87 9-.41 6-.53 12-.5 18 .03 6 .18 12 .51 18-.473-6-.743-12-.81-18-.07-6 0-12 .37-18.06.08-1.5.19-3 .32-4.51.13-1.51.29-3 .53-4.49a32.66 32.66 0 012.5-8.71 12.73 12.73 0 016.07-6.55 11 11 0 018.83.23z"
					></path>
					<path
						fill="#443FC0"
						d="M276.74 121.88h-.11l4.35 10c34-11.86 60.71-36.63 61.84-37.68a5.44 5.44 0 00-7.44-7.94c-.27.28-26.44 24.61-58.64 35.62z"
					></path>
					<path
						fill="#EF8D72"
						d="M343.542 243.995H350.092V260.515H343.542z"
						transform="rotate(-10.04 346.817 252.255)"
					></path>
					<path
						fill="#5F6DB2"
						d="M342.13 254.56a30.19 30.19 0 01-9.86 5.39s-11.27-3.62-8.27 5.29h29.23s1-6.35-.95-10.61c0 0-.72-.33-1.77.65s-4.52 1.56-6.26 1c.01 0-.97-2.05-2.12-1.72z"
					></path>
					<path
						fill="#E9E6ED"
						d="M332.27 260s-11.27-3.67-8.27 5.24h29.23s.15-1.05.22-2.36h-19.26a11.34 11.34 0 00-1.92-2.88zM342.49 258.75a.65.65 0 01-.57-.33 6 6 0 00-2.24-2.35.67.67 0 01-.3-.88.65.65 0 01.88-.3 7.28 7.28 0 012.81 2.89.66.66 0 01-.26.89.61.61 0 01-.32.08zM339.87 260.07a.66.66 0 01-.57-.34 6 6 0 00-2.24-2.35.66.66 0 11.58-1.18 7.22 7.22 0 012.8 2.89.65.65 0 01-.25.89.62.62 0 01-.32.09z"
					></path>
					<path
						fill="#E9E6ED"
						d="M337.25 261.38a.66.66 0 01-.57-.34 6 6 0 00-2.24-2.35.66.66 0 01.57-1.18 7.14 7.14 0 012.81 2.89.67.67 0 01-.25.9.72.72 0 01-.32.08z"
					></path>
					<path
						fill="#EF8D72"
						d="M365.821 244.011H372.37100000000004V260.531H365.821z"
						transform="rotate(-10.04 369.096 252.271)"
					></path>
					<path
						fill="#5F6DB2"
						d="M364.41 254.56a30.05 30.05 0 01-9.86 5.39s-11.23-3.62-8.26 5.29h29.23s1-6.35-.95-10.61c0 0-.72-.33-1.77.65s-4.52 1.56-6.26 1c0 0-.98-2.05-2.13-1.72z"
					></path>
					<path
						fill="#E9E6ED"
						d="M354.55 260s-11.23-3.62-8.26 5.29h29.23s.15-1.05.22-2.36h-19.27a11.34 11.34 0 00-1.92-2.93zM364.78 258.75a.66.66 0 01-.58-.33 5.88 5.88 0 00-2.24-2.35.66.66 0 01-.29-.88.64.64 0 01.87-.3 7.21 7.21 0 012.81 2.89.66.66 0 01-.26.89.6.6 0 01-.31.08zM362.15 260.07a.66.66 0 01-.57-.34 6 6 0 00-2.24-2.35.66.66 0 01.58-1.18 7.21 7.21 0 012.81 2.89.66.66 0 01-.26.89.62.62 0 01-.32.09z"
					></path>
					<path
						fill="#E9E6ED"
						d="M359.53 261.38a.66.66 0 01-.53-.38 6 6 0 00-2.24-2.35.66.66 0 01.58-1.18 7.28 7.28 0 012.81 2.89.67.67 0 01-.26.9.72.72 0 01-.36.12z"
					></path>
					<path
						fill="#666"
						d="M340 158.1l.09-.36c0-.16-.05-.33-.08-.5l-1-10.39h36.33l-1 10.39a19.76 19.76 0 01-.4 2.24 6.26 6.26 0 01-.12 1 236.8 236.8 0 00-4.34 44.73 190 190 0 003.92 36.28c.65 3.51 1.22 6.55 1.58 9.43H363.1c-.31-2.16-.76-4.56-1.27-7.25a204.07 204.07 0 01-4.12-38.34 241.67 241.67 0 013.39-40.7h-10.31a235.25 235.25 0 00-3.57 40.58 191.7 191.7 0 003.92 36.28c.66 3.51 1.23 6.55 1.59 9.43h-11.91c-.32-2.16-.77-4.56-1.27-7.25a203.232 203.232 0 01-4.12-38.34A245.202 245.202 0 01340 158.1z"
					></path>
					<path
						fill="#4D4D4D"
						d="M347.22 205.25c0-2.153.02-4.283.06-6.39-3.63 10.12-8.13 13.36-11.63 14.14a210.89 210.89 0 003.9 30.77c.5 2.7.95 5 1.27 7.32h11.91c-.36-2.89-.93-6-1.59-9.49a192.57 192.57 0 01-3.92-36.35zM373.43 241.6a190.44 190.44 0 01-3.92-36.32v-4.24c-3.75 9.12-8.23 11.68-11.57 12.1a211.09 211.09 0 003.89 30.64c.51 2.69 1 5 1.27 7.31H375c-.35-2.89-.92-5.98-1.57-9.49zM374.46 156.3l.65-6.8H339l.73 4.36c6.57 2.21 17.56 4.28 34.73 2.44z"
					></path>
					<path
						fill="#443FC0"
						d="M349.69 79.58a29.2 29.2 0 0115 0l1.67 3.61H347.5l2.19-3.61z"
					></path>
					<path
						fill="#FFF"
						d="M337.34 150s-4.49-55.5.59-64.8c0 0 6.08-3.51 19.74-3.51 13.87 0 17.85 1.56 22.58 3.51 0 0 2.33 18.74-.94 64.8 0 0-17.45 7.75-41.97 0z"
					></path>
					<path
						fill="#D5E2E2"
						d="M380.25 85.19c-1.29-.53-2.52-1-3.92-1.49-4.6 59.87-26.56 61.83-39.62 57.38.34 5.4.63 8.91.63 8.91 24.52 7.76 42 0 42 0 3.24-46.06.91-64.8.91-64.8z"
					></path>
					<path
						fill="#EF8D72"
						d="M361.73 81.08h-.13V71h-8.2v10.1l-4.81 1.37s1.58 4.4 9 4.4c7 0 9.38-4.69 9.38-4.69l-5.24-1.1zM342.28 48.59s-8.43-3-8.43 5.47c0 8.47 8.43 5.94 8.43 5.94V48.59z"
					></path>
					<path
						fill="#FAA284"
						d="M375.59 57.81c-.67 10.72-8 19.7-18.44 19.7-10.5 0-17.51-9-18.45-19.7l-.53-20.28c0-10.07 8.48-16.7 19-16.7 10.49 0 19 6.63 19 16.7l-.58 20.28z"
					></path>
					<path
						fill="#FAA284"
						d="M374 48.59s8.43-3 8.43 5.47c0 8.47-8.43 5.94-8.43 5.94V48.59z"
					></path>
					<path
						fill="#5656CC"
						d="M347.31 155.19v3.18s-8.74.13-11.38-3.18v-4.5l11.38 4.5zM363.27 155.06l-.11 4.37s12.47.6 16.7-3.24v-6.29l-16.59 5.16z"
					></path>
					<path
						fill="#443FC0"
						d="M348.55 81.68s-2 39-1.09 73.38c0 0-11.17-.66-13-5.16 0 0-4.64-55.32 2.54-64.58a37.85 37.85 0 0111.55-3.64zM366 81.41s-3.24 48.72-2.69 73.65c0 0 10 .93 18.24-4.45 0 0 .22-58.06-.53-65.29A41.12 41.12 0 00366 81.41z"
					></path>
					<path
						fill="#3333AF"
						d="M363.32 143.89c-.05 4 0 7.82 0 11.17 0 0 10 .93 18.24-4.45 0 0 .08-19.12 0-36.79-3.72 12.49-9.56 25.36-18.24 30.07z"
					></path>
					<path fill="#5656CC" d="M349.67 79.56L347.9 97.27 340.13 95.11 344.29 82.01z"></path>
					<path fill="#5656CC" d="M364.7 79.56L365.1 97.27 372.92 95.77 370.45 81.41z"></path>
					<path
						fill="#3333AF"
						d="M334.45 149.3c0 .39.05.6.05.6 1.79 4.5 13 5.16 13 5.16-.08-2.72-.13-5.48-.17-8.24a25.38 25.38 0 01-12.88 2.48z"
					></path>
					<path
						fill="#7F503B"
						d="M348.79 53.84a2.34 2.34 0 11-2.3-2.79 2.57 2.57 0 012.3 2.79z"
					></path>
					<ellipse cx="363.41" cy="53.84" fill="#7F503B" rx="2.3" ry="2.79"></ellipse>
					<path
						fill="#EF8D72"
						d="M353.59 59.3s-3.5-.13-3.5 2.86c0 2.99 5.42 2.23 5.6 0 .18-2.23.47-18.63-2.1-2.86z"
					></path>
					<path
						fill="#D34646"
						d="M349.36 66.26h11.9s1.18 0 .34 1.86c-.54 1.15-2 3.57-6.09 3.68A6.87 6.87 0 01349 68s-.84-1.74.36-1.74z"
					></path>
					<path
						fill="#FFF"
						d="M361.82 67.54c.35-1.24-.56-1.28-.56-1.28h-11.9c-.94 0-.66 1-.49 1.52 2.56.47 8.13 1.22 12.95-.24z"
					></path>
					<path
						fill="#7F503B"
						d="M341.87 48.39l-.24-1.26a30.3 30.3 0 017.44-.39L349 48a29.85 29.85 0 00-7.13.39zM367.8 48.39l.25-1.26a30.35 30.35 0 00-7.44-.39l.1 1.28a29.74 29.74 0 017.09.37z"
					></path>
					<path
						fill="#EF8D72"
						d="M375.47 59.16A7.7 7.7 0 01374 59c-1.28 9-7.18 16-16.83 16.35-9.1.3-13.26-4.1-14.69-6.14a17.19 17.19 0 0014.69 8.32c9.69 0 16.63-7.65 18.17-17.26 2.08.27 5.95.16 6.88-4.11a7.81 7.81 0 01-6.75 3zM357.52 23.91c-11.41 0-20.76 5.27-20.76 15.34l.1 3.36c4.4.19 9.69-3.53 9.69-3.53a8.26 8.26 0 006 3.59 9.09 9.09 0 007.1-2.67c-.14 1 1.35 3.35 4 3.73a5.18 5.18 0 005-2.27A14.18 14.18 0 00378 43.8l.28-3.87c.04-10.07-9.34-16.02-20.76-16.02z"
					></path>
					<path
						fill="#8E6859"
						d="M370.73 37.31s2.8 4.47 2.86 15.92c0 0-.12 1.74.39 1.93.51.19.9.18 1.07-.35.27-.85 1.14-6.61 2.71-6.7l.56-8.81-7.59-1.99zM336.73 37.67s.19 16.87 1.89 17.19l.55-17.19h-2.44z"
					></path>
					<path
						fill="#7F503B"
						d="M347.05 36s-11.41 8.8-13.85-1.46c0 0-5.25-1.41-4.36-6.15a6.81 6.81 0 017.06-5.77s-1.93-5.39 4.23-7.57c6.16-2.18 6.79 1.54 6.79 1.54s4.23-5.13 9.36-1c0 0 7.94-2.91 9.86 2.47 0 0 5.53-3.12 10 2.91a5.36 5.36 0 015.26 3.46c1.66 3.85-1 5.13-1 5.13s2.41 1.58 1.17 6.41c-1.18 4.6-7.43 6.93-14.23 2.44a4.65 4.65 0 01-4.54 2.27c-2.46-.38-3.8-2.68-3.7-3.68 0 0-2.71 3.15-6.56 2.64a7.6 7.6 0 01-5.49-3.64z"
					></path>
					<path
						fill="#6B402F"
						d="M367.14 37.63a6.26 6.26 0 01-8-1.62c-8.12 3.5-12.05-2.09-12.05-2.09-9.74 2-10.94-3.56-10.94-3.56-4.66-2-4.44-5.18-3.91-6.83a6.6 6.6 0 00-3.36 4.87c-.89 4.74 4.36 6.15 4.36 6.15 2.4 10.26 13.81 1.45 13.81 1.45a7.6 7.6 0 005.49 3.58c3.85.51 6.56-2.64 6.56-2.64-.12 1 1.24 3.35 3.67 3.72a4.65 4.65 0 004.54-2.27c6.8 4.49 13.05 2.16 14.23-2.44.156-.57.263-1.152.32-1.74-3.8 6.61-14.72 3.42-14.72 3.42z"
					></path>
					<path
						fill="#EF8D72"
						d="M384.66 142.91L382 141l-2 .41c-1.91-.62-2.75-1.87-3.7-2a8.43 8.43 0 01-2.45-1.15c-.87 1.33.84 2.76.84 2.76l-.4-.08-1-.2-1.25-.25c-.4-.08-.8-.17-1.21-.24a5.91 5.91 0 00-.94-.13 3.53 3.53 0 00-1 .12c-.41.08-2.54.84-2.9.92l-.52.11a1.48 1.48 0 000 1.22c.37.67 1.33.65 1.83.57a9.31 9.31 0 001.21-.37 1.05 1.05 0 01.77-.11c.31 0 .6.14.91.2l2 .46.45.11s-3.21.58-4.21.87a14.41 14.41 0 00-2.85 2.24c-1.52 1.45.86 2 .86 2a1 1 0 00-.28.57.62.62 0 00.22.41c.184.161.403.277.64.34a2.34 2.34 0 001.68-.05l.34-.16.43-.23a10.77 10.77 0 001.28-.79c.05 0 .16-.16.22-.16l2.49-.15c-.84.46-1.7 2-2.84 2.68a2 2 0 00-.49.38.79.79 0 00-.26.58c0 .22.23.28.38.34a2.51 2.51 0 001.51.06 2.93 2.93 0 00.77-.3 3.31 3.31 0 00.52-.34 1.68 1.68 0 00.21-.18c1.52-1.69 3.2-2.53 5.36-1.42 3.12 1.61 5.56-3 5.56-3l.48-4.13z"
					></path>
					<path
						fill="#443FC0"
						d="M404.86 111.07c2.19 11.66-3.81 24-17.83 36.55l-8.75-8.21.15-.14c7.64-6.75 16.38-16.73 14.67-26-1.17-6.27-7.1-11.27-12.25-14.42l-.51-13.71c5.42 2.37 21.66 10.62 24.52 25.93z"
					></path>
				</g>
			</g>
		</svg>
	);
}

export default FeedbackRespondInstructionsIllustration;
